import { axiosInstance as request } from '@/api/rest.service'

export const getSpreadsheetInformation = () => request.get('/data/spreadsheet-information')
export const startImport = entity => request.post(`/data/${entity}/import`)
